import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';
import { comparisonRows } from '@/mocks/mt4mt5Page';

export default function ComparisonSection() {
  return (
    <section id="compare" className="scroll-mt-24 border-b border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="เปรียบเทียบแพลตฟอร์ม"
          title="MT4 และ MT5 แตกต่างกันอย่างไร"
          subtitle="ทำความเข้าใจความแตกต่างของแพลตฟอร์มทั้งสอง เพื่อเลือกศึกษาเครื่องมือที่เหมาะกับความต้องการของคุณ"
        />

        <div className="mt-9 hidden grid-cols-[200px_1fr_1fr] gap-4 px-5 md:grid lg:grid-cols-[220px_1fr_1fr]">
          <span className="text-xs font-semibold uppercase tracking-wide text-foreground-500">หัวข้อเทียบ</span>
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            MT4
          </span>
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            MT5
          </span>
        </div>

        <div className="mt-4 flex flex-col gap-3">
          {comparisonRows.map((row, index) => (
            <ScrollReveal key={row.dimension} delay={index * 60}>
              <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-4 md:px-5 md:py-5">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-[200px_1fr_1fr] lg:grid-cols-[220px_1fr_1fr]">
                  <div className="flex items-start gap-2.5">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                      <i className={`${row.icon} text-base`} />
                    </span>
                    <p className="font-heading text-sm font-semibold leading-snug text-foreground-950 md:pt-1">
                      {row.dimension}
                    </p>
                  </div>

                  <div className="rounded-md bg-primary-50/70 px-3 py-3">
                    <span className="mb-1.5 inline-flex items-center gap-1.5 text-[11px] font-semibold text-primary-700 md:hidden">
                      <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                      MT4
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-700">{row.mt4}</p>
                  </div>

                  <div className="rounded-md bg-accent-50/70 px-3 py-3">
                    <span className="mb-1.5 inline-flex items-center gap-1.5 text-[11px] font-semibold text-accent-700 md:hidden">
                      <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                      MT5
                    </span>
                    <p className="text-sm leading-relaxed text-foreground-700">{row.mt5}</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <div className="mt-6 flex items-start gap-3 rounded-lg border border-accent-200 bg-accent-50/70 px-4 py-3.5">
          <i className="ri-information-line mt-0.5 shrink-0 text-base text-accent-700" />
          <p className="text-xs leading-relaxed text-foreground-700 md:text-sm">
            รายละเอียดอาจแตกต่างตามเวอร์ชันของแพลตฟอร์มและสิ่งที่โบรกเกอร์เปิดให้ใช้งาน
            ไม่มีแพลตฟอร์มใดดีกว่ากันในทุกด้าน ควรเลือกจากสินทรัพย์ที่คุณจะเทรดและเครื่องมือที่โบรกเกอร์รองรับเป็นหลัก
          </p>
        </div>
      </div>
    </section>
  );
}